import React from 'react';
import { useDispatch } from 'react-redux';
import { Grid, makeStyles } from '@material-ui/core';
import {
  reduxForm, InjectedFormProps, Field, initialize,
} from 'redux-form';
import Button from '../../Button/Button';
import FormRedux from '../../FormRedux/FormRedux';
import {
  required, existAnswerDnD, formatAnswerDnD, existOneAnswerDnD,
} from '../../../helpers/validate-forms';
import Input from '../../Input/Input';

const useStyles = makeStyles(() => ({
  items: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    columnGap: 10,
    marginBottom: 10,
  },
}));

const QuestionFormDnD:
React.FC<InjectedFormProps> = ( props ) => {
  const classes = useStyles();
  const { handleSubmit, submitting } = props;
  const dispatch = useDispatch();

  const handleReset = (): void => {
    dispatch( initialize( 'question-dnd', undefined ));
  };

  return (
    <FormRedux
      onSubmit={handleSubmit}
    >
      <Grid container className={classes.items} spacing={1}>
        <Grid item xs={12} sm={7} md={8}>
          <Field
            name="sentence"
            type="text"
            label="Oración a completar"
            component={Input}
            validate={[
              required, existAnswerDnD, formatAnswerDnD, existOneAnswerDnD]}
            multiline
          />
          <Field
            name="optionCorrect"
            type="text"
            label="Opción correcta"
            component={Input}
            validate={[required]}
          />
          <Field
            name="optionIncorrect1"
            type="text"
            label="Opción incorrecta"
            component={Input}
            validate={[required]}
          />
          <Field
            name="optionIncorrect2"
            type="text"
            label="Opción incorrecta"
            component={Input}
          />
          <Field
            name="optionIncorrect3"
            type="text"
            label="Opción incorrecta"
            component={Input}
          />
        </Grid>
        <Grid item xs={12} className={classes.buttonContainer}>
          <Button type="submit" disabled={submitting}>
            Guardar
          </Button>
          <Button color="error" onClick={handleReset}>
            Limpiar
          </Button>
        </Grid>
      </Grid>
    </FormRedux>
  );
};

export default reduxForm({
  form: 'question-dnd',
})( QuestionFormDnD );
